import React, {useState} from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {MODELS} from "../../../../Apis/Models";
import {TABLES} from "../../../../Apis/Tables";
import {USER_TYPE_NAME_MODEL} from "../../../../enums/userTypeEnum";


/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const MaterialRequestMainApp = () => {
    const navigate = useNavigate();
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [modified, setModified] = useState(false);
    const { t } = useTranslation();
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState(null);
    const { permission, user } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [searchElement, setSearchElement] = useState('');
    const [selectedList, setSelectedList] = useState([]);
    const isGuard = user?.data?.userType?.name === USER_TYPE_NAME_MODEL.GUARD;
    const moduleId = MODELS.MATERIAL_REQUEST;
    const option = TABLES.MATERIAL_REQUEST;

    return {
        t,
        navigate,
        setBodyForExport,
        permission,
        isGuard,
        DEV,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        modified,
        search,
        moduleId,
        option,
        bodyForExport,
        isAllChecked,
        setIsAllChecked,
        selectedList,

    }
};
